export default {
  'canonical-urls': true,
  'test-feature-toggle': true,
  'b2b-page': true,
};
